/**
 * Replacement for Next.js `polyfill-module`.
 *
 * Next 15.5 still injects legacy polyfills (Array.at, flat, Object.hasOwn, …)
 * into every page's shared client chunk even though they are native in Baseline
 * / Next-supported browsers — PageSpeed flags ~11.6 KiB of wasted bytes.
 *
 * This stub drops those no-ops and keeps only `URL.canParse`, which is still
 * missing on Safari 16.4 (Next's current Safari floor).
 *
 * Build-wide on purpose: the polyfill chunk is shared across all routes and
 * cannot be scoped to a single page. Runtime behavior on modern browsers is
 * unchanged (those APIs were already native; the old module was dead weight).
 */
"canParse" in URL ||
  (URL.canParse = function (url, base) {
    try {
      return !!new URL(url, base);
    } catch {
      return false;
    }
  });
